"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "buja": {
    "469f82ed": [{
      "hkey": "a1ffb7ba",
      "slug": "buja",
      "name": "Buja",
      "primary": true,
      "skipSearch": false
    }],
    "avilla": [{
      "hkey": "a1ffb7ba",
      "slug": "buja",
      "name": "Buja",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "42f581ce": [{
      "hkey": "a1ffb7ba",
      "slug": "buja",
      "name": "Buja",
      "primary": true,
      "skipSearch": false
    }],
    "madonna": [{
      "hkey": "a1ffb7ba",
      "slug": "buja",
      "name": "Buja",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "be09c359": [{
      "hkey": "a1ffb7ba",
      "slug": "buja",
      "name": "Buja",
      "primary": true,
      "skipSearch": false
    }],
    "monte": [{
      "hkey": "a1ffb7ba",
      "slug": "buja",
      "name": "Buja",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "35776134": [{
      "hkey": "a1ffb7ba",
      "slug": "buja",
      "name": "Buja",
      "primary": true,
      "skipSearch": false
    }],
    "san-floreano": [{
      "hkey": "a1ffb7ba",
      "slug": "buja",
      "name": "Buja",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "843331ec": [{
      "hkey": "a1ffb7ba",
      "slug": "buja",
      "name": "Buja",
      "primary": true,
      "skipSearch": false
    }],
    "sopramonte": [{
      "hkey": "a1ffb7ba",
      "slug": "buja",
      "name": "Buja",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bdd18cb6": [{
      "hkey": "a1ffb7ba",
      "slug": "buja",
      "name": "Buja",
      "primary": true,
      "skipSearch": false
    }],
    "tomba": [{
      "hkey": "a1ffb7ba",
      "slug": "buja",
      "name": "Buja",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fd2c1f64": [{
      "hkey": "a1ffb7ba",
      "slug": "buja",
      "name": "Buja",
      "primary": true,
      "skipSearch": false
    }],
    "urbignacco": [{
      "hkey": "a1ffb7ba",
      "slug": "buja",
      "name": "Buja",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "342f3e08": [{
      "hkey": "a1ffb7ba",
      "slug": "buja",
      "name": "Buja",
      "primary": true,
      "skipSearch": false
    }],
    "ursinis-grande": [{
      "hkey": "a1ffb7ba",
      "slug": "buja",
      "name": "Buja",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;